export default "__VITE_ASSET__BBOAT2QH__"